const LocalStorage = window.localStorage;
const SessionStorage = window.sessionStorage;

const ACCESS_TOKEN_NAME = 'accessToken';
const REDIRECT_ROUTER_PATH = 'redirectRouterPath';

class StorageService {
  getItem = key => {
    const item = LocalStorage.getItem(key);
    return item;
  };
  setItem = (key: string, value) => {
    LocalStorage.setItem(key, value.toString());
  };
  removeItem = (key: string) => {
    LocalStorage.removeItem(key);
  };

  removeAccessToken = (accessTokenName = ACCESS_TOKEN_NAME) => {
    LocalStorage.removeItem(accessTokenName);
    SessionStorage.removeItem(accessTokenName);
  };

  setAccessToken = (value, accessTokenName = ACCESS_TOKEN_NAME) => {
    LocalStorage.setItem(accessTokenName, value.toString());
    SessionStorage.setItem(accessTokenName, value.toString());
  };

  getAccessToken = (accessTokenName = ACCESS_TOKEN_NAME) => {
    const localAccessToken = LocalStorage.getItem(accessTokenName);
    const sessionAccessToken = SessionStorage.getItem(accessTokenName);

    if (
      localAccessToken &&
      (!sessionAccessToken || localAccessToken !== sessionAccessToken)
    ) {
      SessionStorage.setItem(accessTokenName, localAccessToken);

      return localAccessToken;
    }

    if (!localAccessToken || localAccessToken !== sessionAccessToken) return undefined;

    return localAccessToken;
  };

  setRedirectRoutePath = (value: string) => {
    SessionStorage.setItem(REDIRECT_ROUTER_PATH, value);
  };

  getRedirectRoutePath = () => {
    return SessionStorage.getItem(REDIRECT_ROUTER_PATH);
  };

  removeRedirectRoutePath = () => {
    SessionStorage.removeItem(REDIRECT_ROUTER_PATH);
  };
}

export default new StorageService();
